import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ca-large-card',
  templateUrl: 'large-card.component.html',
  styleUrls: ['large-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaLargeCard {
  @Input()
  addPadding = true;
}
